module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAU5FCvBmQAAAKlJREFUOMtjYBj+QFle3lBJTj4QlzwTXs1yilYMDIznmBgZBciwWcFBSV7hv6KsXDHJmhXl5Z2U5RX+K8kpRpGsWUlO3kdRVu6/srwCUZpZ0AUYGRmTGBgYnzD/ZtpOjAEYgfjhz58QRoZ/F/+y/rslLysnTnb0KcorzFKWV3ijJC+nQYkhS5XlFT4rycmp4FLDjM+ADx8/rBPi52dgYGT0eP/x49ZhmlcASpkjnx2uzJ4AAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowleft.png
 ** module id = 246
 ** module chunks = 0 1
 **/